export const rstatProgressMessages = {
    firstStepEnabled: 'Sensor is online',
    firstStepError: 'Sensor is offline',
};
